const defaultSettings = {
  apiBaseUrl: ""
};

let cachedSettings = { ...defaultSettings };

export async function loadAppSettings() {
  try {
    const response = await fetch("/appsettings.json", { cache: "no-store" });
    if (!response.ok) {
      throw new Error(`Failed to load appsettings.json (${response.status})`);
    }

    const parsed = await response.json();
    cachedSettings = {
      ...defaultSettings,
      ...parsed
    };
  } catch {
    cachedSettings = { ...defaultSettings };
  }
}

export function getApiBaseUrl() {
  const raw = cachedSettings.apiBaseUrl ?? "";
  return String(raw).replace(/\/+$/, "");
}
